import React from 'react';

interface FormColContextProps {
  colId?: string;
  defaultCol?: number;
  minColWidth?: number;
  gutterWidth?: number;
  label?: string;
}

const FormColContext = React.createContext<FormColContextProps>({});

export default FormColContext;
